exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.container-table[data-v-12122e96] {\r\n    margin-bottom: 20px;\n}\n.tables th[data-v-12122e96] {\r\n    border: none;\n}\n.button-page[data-v-12122e96] {\r\n    float: right;\r\n    margin-right: 0.5em;\n}\n.no-border[data-v-12122e96] {\r\n    border: hidden;\r\n    background: none;\n}\nth[data-v-12122e96] {\r\n    padding: 1em;\n}\ntd[data-v-12122e96] {\r\n    padding: 1em;\n}\r\n", ""]);

// exports
